import React, { Component } from 'react';
import BigNumber from '../../lib/bignumber';
import { IonRow, IonCol, IonIcon } from '@ionic/react';
import Basket from '../../lib/basket';
import { NormalText, SmallText, Spacer, StrongText, Subtitle } from '../common';
import { withTranslation } from '../../lib/translate';
import { isDefined, isEmptyObject } from '../../lib/utils';
import './index.css';
import { cardOutline } from 'ionicons/icons';
import { ReactComponent as CardVisa } from '../../assets/images/card-visa.svg';
import { ReactComponent as CardMastercard } from '../../assets/images/card-mastercard.svg';
import { ReactComponent as CardGooglePay } from '../../assets/images/card-google-pay.svg';
import { ReactComponent as CardApplePay } from '../../assets/images/card-apple-pay.svg';
import { ReactComponent as CardDefault } from '../../assets/images/card-default.svg';

class AmountPaid extends Component {
	determineOrderStatus = (order) => {
		const status = order.status.toLowerCase();

		switch (status) {
			case 'paid':
				return 'Completed';
			case 'failed':
			case 'unpaid':
			case 'declined':
				return 'Failed';
			case 'refunded':
				return 'Refunded';
			case 'cancel':
				return 'Cancel';
			default:
				return 'Processing';
		}
	};

	render() {
		const { __, order, cards } = this.props;
		let amount_paid = isDefined(order.amount_paid) ? order.amount_paid : 0;
		if (amount_paid > 0) {
			amount_paid = new BigNumber(amount_paid).div(100).toNumber();
		}
		let label = 'Card';
		let labelNumber = null
		let icon = <CardDefault />
		if ((order.payment_token && cards && cards.length > 0) || !isEmptyObject(order.payment_info)) {
			const card = !isEmptyObject(order.payment_info) ? order.payment_info.card : cards.find((c) => c.id === order.payment_token);
			if (card) {
				const { brand, last4, is_error, message, type } = card;
				const labels = {
					'apple_pay': `Apple Pay (${brand})`,
					'google_pay': `Google Pay (${brand})`,
					'card': `${brand} card`
				}
				if (type == 'apple_pay') {
					icon = <CardApplePay />
				}
				else if (type == 'google_pay') {
					icon = <CardGooglePay />
				}
				else {
					if (brand == 'visa') {
						icon = <CardVisa />
					} else if (brand == 'mastercard') {
						icon = <CardMastercard />

					}
				}
				label = labels[type];
				labelNumber = `**** **** **** ${last4}`
				if (is_error) {
					label = message
				} else {

					label = `**** **** **** ${last4}`;
					labelNumber = `${card.exp_month}/${card.exp_year}`
				}
			}
		}
		return (
			<>
				{order.amount_paid > 0 &&
					<>
						{order && order.payment_token === 'Pay on collection' && order.status !== 'PAID' ? (
							<>
								<StrongText className="text-to-update">{__('Payment details')}</StrongText>
								<Spacer size={2} />
								<div className="box-content">

									<div className="ion-color-danger text-box">
										<SmallText color="red"> {__('PAYMENT DUE ON COLLECTION')}</SmallText>
									</div>
								</div>
							</>
						) :
							(

								<>
									{order.status.toLowerCase() == 'new' ? <>
										<div className="no-data-history" >
											<NormalText>{__('Payment card details will be displayed once the order has been paid.')}</NormalText>
										</div>

									</> :
										<>
											<StrongText className="text-to-update">{__('Payment details')}</StrongText>
											<Spacer size={2} />

											<div className='box-content'>
												<IonRow className="no-border">
													<IonCol class='paddLR '>
														<div className="card-icon-wrapper">
															{icon}
														</div>
													</IonCol>
													<IonCol className="paddLR grow">
														<StrongText className="card-label block">{__(label)}</StrongText>
														{labelNumber && <StrongText className="card-label block">{labelNumber}</StrongText>}

													</IonCol>

												</IonRow>
												{order && order.process_message ? (
													<IonRow style={{ padding: 0 }} className="ion-color-danger">
														<IonCol className="paddLR ion-color-danger">
															<SmallText color="red">*** {__(order.process_message)} ***</SmallText>
														</IonCol>
													</IonRow>

												) : null}
											</div>
										</>
									}
								</>
							)}
							<Spacer size={5}/>
					</>
				}
			</>
		);
	}
}

export default withTranslation(AmountPaid);
